export default "<app-navigation-bar></app-navigation-bar>\n<app-site></app-site>\n"